import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShaderEffect"><Path d="M21 21H3V20.9141L20.9141 3H21V21Z" fill="currentColor"/><Path d="M3 18.0859V13.4141L13.4141 3H18.0859L3 18.0859Z" fill="currentColor"/><Path d="M3 10.5859V3H10.5859L3 10.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
